/**
 * The offline-ready badge rule, applied to the service worker's own report
 * (useOffline in src/features/offline: `controlled`, `shellCached`,
 * `dataCached`). OFFLINE READY only when a service worker controls this page
 * and has reported the app shell AND the bundled data cached; anything else is
 * OFFLINE NOT CACHED. The data counts too: without /data the loader and the
 * twins cannot boot offline, so a shell-only cache would promise a demo that
 * fails on its first data request.
 */
import type { OfflineState } from '@/features/offline';

export type PresenterOfflineBadge = 'ready' | 'not-cached';

export function offlineBadge(
  state: Pick<OfflineState, 'controlled' | 'shellCached' | 'dataCached'>,
): PresenterOfflineBadge {
  return state.controlled && state.shellCached && state.dataCached ? 'ready' : 'not-cached';
}
